<template>
  <div>
    <PageTitle :title="$t('PRIZES.TITLE')" class="page-title"/>

    <PrizeBox v-for="prize in prizeItems"
              :key="prize.id"
              :title="prize.title"
              :subtitle="prize.subtitle"
              :description="prize.description"
              :link-text="prize.linkText"
              :link="prize.link"
              :image="prize.image"
              class="prize"/>
  </div>
</template>

<script>
import PageTitle from '@/components/elements/texts/PageTitle'
import PrizeBox from '@/components/elements/prizes/PrizeBox'

export default {
  name: 'Prizes',
  components: {
    PrizeBox,
    PageTitle
  },
  setup() {
    const prizeItems = [
      {
        id: 32,
        title: '1e prijs • Beeld en Geluid + Meet & greet MediaMasters cast',
        subtitle: 'Met de hele klas naar Beeld en Geluid Den Haag + Meet & Greet met de cast van MediaMasters (incl. vervoer)',
        description: 'De winnaars van MediaMasters brengen met hun klas en begeleiders een bezoek aan Beeld en Geluid Den Haag. Ook krijgen zij een workshop Verhalenfabriek cadeau! Aansluitend op deze workshop krijgen de winnaars ook nog eens een Meet & Greet met de cast van MediaMasters.',
        linkText: 'Kijk op de Beeld en Geluid website  voor meer informatie.',
        link: '',
        image: 'https://images.unsplash.com/photo-1589869571832-6db8facdad09?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1350&q=80'
      },
      {
        id: 55,
        title: '2e prijs • Eye Filmmuseum',
        subtitle: 'Met de hele klas naar Eye Filmmuseum (incl. vervoer)',
        description: 'Een bezoek aan het enige filmmuseum van Nederland: Eye Filmmuseum Amsterdam. Zij gaan op reis door de wereld van film. Leer hoe filmmakers je meenemen in de meest wonderlijke werelden, door het gebruik van camera, special effects, muziek, licht en geluid.',
        linkText: 'Kijk op de Eye filmmuseum website voor meer informatie.',
        link: '',
        image: 'https://images.unsplash.com/photo-1617050055577-f3f9c5548ca0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2795&q=80'
      },
      {
        id: 44,
        title: '3e prijs • Storyworld',
        subtitle: 'Met de hele klas naar Storyworld (excl. vervoer)',
        description: 'Wat is een beeldverhaal? En hoe wordt het gemaakt? In dit museum staat het maakproces van strips, animatie en games centraal. Neem een kijkje achter de schermen bij de studio’s en bekijk originele schetsen en storyboards.',
        linkText: 'Kijk op de Storyworld website voor meer informatie.',
        link: '',
        image: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
      }
    ]

    return {
      prizeItems
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.mixins";

.prize {
  &:not(:last-child) {
    margin-bottom: rem(20);
  }
}
</style>
